import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { FloatingCTA } from "./components/FloatingCTA";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Collaborate } from "./pages/Collaborate";
import { LivingWater } from "./pages/LivingWater";
import { Gallery } from "./pages/Gallery";

function App() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/living-water" element={<LivingWater />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/collaborate" element={<Collaborate />} />
        </Routes>
        <Footer />
        <FloatingCTA />
      </BrowserRouter>
    </div>
  );
}

export default App;
